import { render, staticRenderFns } from "./DelegationEditView.vue?vue&type=template&id=3cfbaed4&scoped=true&"
import script from "./DelegationEditView.vue?vue&type=script&lang=js&"
export * from "./DelegationEditView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cfbaed4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/srv/dev/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3cfbaed4')) {
      api.createRecord('3cfbaed4', component.options)
    } else {
      api.reload('3cfbaed4', component.options)
    }
    module.hot.accept("./DelegationEditView.vue?vue&type=template&id=3cfbaed4&scoped=true&", function () {
      api.rerender('3cfbaed4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/delegation/DelegationEditView.vue"
export default component.exports